import React from 'react';

const Footer = () => (
  <div className="footer text-white pt-3">
    <p>&copy; & Project made by Avijit, Microverse</p>
  </div>
);

export default Footer;
